import { Suspense, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';


import { type RouteProp, publicRoutes, routes } from './routes';
import {type RootState } from '../../../rootState';

import { useAuth } from '@/auth/application/authController';

// Exposes the React Router navigate function on globalThis so Cypress tests can
// trigger SPA navigation without a full page reload (avoiding Redux state loss).
const DevNavigateBridge = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (import.meta.env.DEV) {
            (globalThis as any).__navigate = navigate;
        }
    }, [navigate]);
    return null;
};

const Navigator = () => {
    const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

    const { checkAuthState } = useAuth();

    useEffect(() => {
        checkAuthState();
    }, [isAuthenticated, checkAuthState]);

    // Filter routes based on authentication status
    const filteredRoutes = isAuthenticated ? routes : publicRoutes;
    
    const findRouteElement = (routes: RouteProp[], parent?: string) => {
        return routes.map(item => (
            <Route key={parent + item.path} path={item.path} element={ item.element }>
                { item.children ? findRouteElement(item.children, item.path + parent) : null }
            </Route>
        ));
    };
    const routeElements = findRouteElement(filteredRoutes);

    return <BrowserRouter><DevNavigateBridge /><Suspense fallback={null}><Routes>{routeElements}</Routes></Suspense></BrowserRouter>;
};

export default Navigator;